RivalIQ.apps.Companies.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ChangeFocusCompany = Marionette.CompositeView.extend({
        ui: {
            modal: '.modal'
        },
        childEvents: {
            activated: 'onItemActivated'
        },
        tagName: 'span',
        template: '#changeFocusCompanyTemplate',
        childViewContainer: 'ul',
        childView: views.ChangeFocusCompanyItem,
        childViewOptions: function (model) {

            const me = this;
            const activeModel = me.model.get('activeModel');

            const result = {
                active: activeModel.id === model.id
            };

            return result;
        },
        templateHelpers: function () {

            const me = this;
            const model = me.model;
            const activeModel = model.get('activeModel');

            const result = {
                name: activeModel.get('name')
            };

            return result;
        },
        onItemActivated: function (view) {

            const me = this;
            const model = view.model;

            // trigger the selection change AFTER the modal goes away, but only once
            me.ui.modal.one('hidden.bs.modal', function () {
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangedFocusCompany);

                const updatedAttributes = {
                    focusCompanyId: model.id
                };

                const companySetDescriptor = RivalIQ.state.view.get('companySetDescriptor');
                const companies = RivalIQ.state.landscape.getCompaniesByCompanySet(companySetDescriptor);

                const newFocusCoInSet = (companies.findIndex(company => company.id === model.id) >= 0);
                if (!newFocusCoInSet) {
                    // TODO clean up use of tag here
                    updatedAttributes.tag = RivalIQ.state.companySets.none;
                    updatedAttributes.companySetDescriptor = RivalIQ.state.companySets.none;
                    RivalIQ.execute('alert:info', '<p>We cleared the company set filter to show all companies.</p>');
                }

                RivalIQ.state.view.set(updatedAttributes);
            }).modal('hide');
        }
    });

});
